import { ComponentType, SVGProps } from "react";
import styles from "./IconButton.module.css";

export enum IconButtonSize {
  S = 'small',
  M = 'medium',
  L = 'large',
  XL = 'extraLarge'
}

export enum IconButtonKind {
  OUTLINED,
  FILLED,
  EMPTY
}

export enum IconButtonShape {
  ROUNDED,
  SQUARE
}

interface IconButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, React.AriaAttributes {
  preventDefault?: boolean;
  stopPropagation?: boolean;
  size?: IconButtonSize,
  kind?: IconButtonKind,
  shape?: IconButtonShape,
  selected?: boolean,
  icon: ComponentType<SVGProps<SVGSVGElement>>
}

export const IconButtonKindMap: Record<IconButtonKind, string> = {
  [IconButtonKind.OUTLINED]: 'outlined',
  [IconButtonKind.FILLED]: 'filled',
  [IconButtonKind.EMPTY]: 'empty'
}

export const IconButtonShapeMap: Record<IconButtonShape, string> = {
  [IconButtonShape.ROUNDED]: 'rounded',
  [IconButtonShape.SQUARE]: 'square'
}

export default function IconButton({ shape = IconButtonShape.ROUNDED, kind = IconButtonKind.FILLED, icon: Icon, className, children, size = IconButtonSize.S, selected = false, preventDefault = true, stopPropagation = true, ...rest }: IconButtonProps) {

  return (
    <button
      className={`
        ${styles.main}
        ${className}
        ${size ?? ''}
        ${styles[IconButtonShapeMap[shape]]}
        ${styles[IconButtonKindMap[kind]]}
        ${selected ? styles.selected : ''}
      `}
      {...rest}
    >
      <Icon />
    </button>
  )
}
